import LeftArrow from "./LeftArrow";

export default LeftArrow;
